import React, { useMemo } from 'react';
import { formatLongWeekdayMonthDayIST } from '../../utils/timezoneDisplay';

const TodaysBirthdaysCard = ({ birthdays, loading, count }) => {
  const todayLabel = useMemo(() => formatLongWeekdayMonthDayIST(new Date()), []);

  return (
    <section className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
      <div className="flex items-center gap-2 border-b border-gray-100 bg-pink-50/60 px-3 py-2 md:px-4 md:py-2.5">
        <span className="text-lg leading-none md:text-xl" aria-hidden>
          🎂
        </span>
        <div className="min-w-0">
          <h3 className="flex flex-wrap items-center gap-1.5 text-sm font-semibold text-gray-900 md:text-base">
            <span>Today&apos;s Birthdays</span>
            {count > 0 && (
              <span className="inline-flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-pink-500 px-1.5 text-xs font-bold text-white">
                {count}
              </span>
            )}
          </h3>
          <p className="truncate text-[11px] text-gray-500 md:text-xs">{todayLabel}</p>
        </div>
      </div>

      <div className="px-3 py-2 md:px-4 md:py-3">
        {loading ? (
          <div className="flex justify-center py-6 md:py-8">
            <div className="h-7 w-7 animate-spin rounded-full border-2 border-pink-400 border-t-transparent md:h-9 md:w-9" />
          </div>
        ) : birthdays.length === 0 ? (
          <div className="py-6 text-center text-gray-500 md:py-8">
            <p className="text-2xl md:text-3xl" aria-hidden>
              🎈
            </p>
            <p className="mt-1 text-sm font-medium text-gray-700">No birthdays today</p>
          </div>
        ) : (
          <ul className="space-y-1">
            {birthdays.map((b) => (
              <li
                key={`${b.entity_type}-${b.entity_id}`}
                className="text-sm font-medium text-gray-900 md:text-[15px]"
              >
                {b.full_name}
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
};

export default TodaysBirthdaysCard;
